import { render } from "./Header.vue?vue&type=template&id=2ee23aa6&scoped=true&bindings={\"title\":\"data\",\"menuItems\":\"data\",\"$_openPage\":\"options\",\"$_openSubMenu\":\"options\"}"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=2ee23aa6&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-2ee23aa6"

export default script